import { render, staticRenderFns } from "./riskThirdStandard.vue?vue&type=template&id=2eba9d8c"
import script from "./riskThirdStandard.vue?vue&type=script&lang=js"
export * from "./riskThirdStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eba9d8c')) {
      api.createRecord('2eba9d8c', component.options)
    } else {
      api.reload('2eba9d8c', component.options)
    }
    module.hot.accept("./riskThirdStandard.vue?vue&type=template&id=2eba9d8c", function () {
      api.rerender('2eba9d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/riskThirdStandard.vue"
export default component.exports